import { Navigate } from "react-router-dom";
import PageTitle from "../page-header/PageHeader";
import AddMeeting from "./AddMeeting";
import GetAllMeetings from "./GetAllMeetings";
import { Col, Row, Form } from "antd";
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import { loadAllStaff } from "../../redux/rtk/features/user/userSlice";

const Meetings = () => {
	const [form] = Form.useForm();
	const dispatch = useDispatch();
	const isLogged = Boolean(localStorage.getItem("isLogged"));
	const staffList = useSelector((state) => state.users?.list || []);

	const [meetings, setMeetings] = useState(() => {
		// Try to load from localStorage first
		const storedMeetings = localStorage.getItem("meetings");
		if (storedMeetings) {
			try {
				return JSON.parse(storedMeetings);
			} catch (error) {
				console.error("Error parsing meetings from localStorage:", error);
			}
		}
		// Default initial data
		const now = dayjs();
		return [
			{
				id: 1,
				managerName: "Alex Johnson",
				managerId: 101,
				employeeName: "Priya Verma",
				employeeId: 201,
				meetingDate: now.add(1, "day").format("YYYY-MM-DD"),
				meetingTime: "10:00",
				location: "Conference Room A",
				agenda: "Quarterly performance discussion",
				status: "Scheduled",
			},
			{
				id: 2,
				managerName: "Sara Smith",
				managerId: 102,
				employeeName: "Rahul Das",
				employeeId: 202,
				meetingDate: now.add(2, "day").format("YYYY-MM-DD"),
				meetingTime: "15:30",
				location: "Zoom",
				agenda: "Project status and blockers",
				status: "Scheduled",
			},
		];
	});

	useEffect(() => {
		dispatch(loadAllStaff({ status: true }));
	}, [dispatch]);

	// Sync meetings to localStorage whenever they change
	useEffect(() => {
		localStorage.setItem("meetings", JSON.stringify(meetings));
	}, [meetings]);

	const mapEmployeeName = (employeeId) => {
		const employee = staffList.find(
			(e) =>
				String(e.id ?? e.EmployeeId ?? e.EmployeeID ?? e.UserId ?? e.UserID) ===
				String(employeeId)
		);
		if (employee) {
			return (
				employee.EmployeeName ||
				`${employee.firstName || ""} ${employee.lastName || ""}`.trim() ||
				employee.UserName
			);
		}
		return "Unknown";
	};

	const handleSubmit = (values) => {
		const newId = meetings.length ? Math.max(...meetings.map((m) => m.id || 0)) + 1 : 1;
		const payload = {
			id: newId,
			managerId: values.managerId,
			employeeId: values.employeeId,
			managerName: mapEmployeeName(values.managerId),
			employeeName: mapEmployeeName(values.employeeId),
			meetingDate: values.meetingDate ? dayjs(values.meetingDate).format("YYYY-MM-DD") : null,
			meetingTime: values.meetingTime ? dayjs(values.meetingTime).format("HH:mm") : null,
			location: values.location,
			agenda: values.agenda,
			notes: values.notes || "",
			status: values.status || "Scheduled",
		};
		setMeetings((prev) => [...prev, payload]);
		form.resetFields();
	};

	const handleEdit = (record) => {
		form.setFieldsValue({
			managerId: record.managerId,
			employeeId: record.employeeId,
			meetingDate: record.meetingDate ? dayjs(record.meetingDate) : null,
			meetingTime: record.meetingTime ? dayjs(record.meetingTime, "HH:mm") : null,
			location: record.location,
			agenda: record.agenda,
			notes: record.notes || "",
			status: record.status,
		});
	};

	const refresh = () => {
		// Refresh meetings list
		setMeetings((prev) => [...prev]);
	};

	if (!isLogged) {
		return <Navigate to={"/admin/auth/login"} replace={true} />;
	}

	return (
		<div className="add-meeting-page-wrapper">
			
			<Row gutter={16} className="add-meeting-row">
				<Col xs={24} sm={24} md={10} lg={8} className="add-meeting-form-col">
					<AddMeeting form={form} onSubmit={handleSubmit} />
				</Col>
				<Col xs={24} sm={24} md={14} lg={16} className="add-meeting-table-col">
					<GetAllMeetings data={meetings} onEdit={handleEdit} onRefresh={refresh} />
				</Col>
			</Row>
		</div>
	);
};

export default Meetings;

